<div class="block-container" fxLayout="column" fxLayoutGap="12px">
	<div class="ds-description">
		{{ description }}
		<span class="ds-required"> *</span>
	</div>

	<ahs-text
		#ref
		id="amount"
		[required]="true"
		[customValidationMessages]="customValidationMessages"
		tabOrder="1"
		[ahsFormGroup]="formGroup"
		appearance="outline"
		[required]="true"
		(tabKeyPressed)="markAllFieldsAsTouched()"
		(valueChanged)="markAllFieldsAsTouched()"
		(blur)="markAllFieldsAsTouched()"
	></ahs-text>

	<div class="ds-description" style="margin-top: 14px" *ngIf="showRemaining">
		Remaining Payment Balance: {{ maxValue - formGroup.controls['amount'].value | number: '1.2' }}
	</div>
</div>
